import { IconProps } from '../types'

export const AreaDark = ({ className }: IconProps) => {
  return (
    <svg
      width='61'
      height='60'
      viewBox='0 0 61 60'
      fill='none'
      className={className}
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='60' height='60' rx='30' fill='#48785D' />
      <path
        d='M32.9129 34.8135C31.6912 37.0706 30.4469 39.0672 30.0255 39.7313C29.9577 39.6212 29.869 39.4754 29.7625 39.2986C29.5343 38.9194 29.2259 38.3995 28.8712 37.7855C28.161 36.5564 27.2681 34.956 26.4604 33.3559C25.8724 32.1911 25.3353 31.0374 24.9467 30.0328C24.5476 29.0009 24.3418 28.2158 24.3418 27.7511C24.3418 24.6627 26.8869 22.1329 30.0238 22.1328C33.1657 22.1328 35.7058 24.6623 35.7058 27.7511C35.7058 28.429 35.4009 29.4942 34.8652 30.796C34.3408 32.0701 33.6342 33.4809 32.9129 34.8135Z'
        stroke='currentColor'
        stroke-width='1.5'
      />
      <path
        d='M17.5 29.2674V43.8996C17.5 43.955 17.545 44 17.6005 44H43.3996C43.455 44 43.5 43.955 43.5 43.8996V17.1005C43.5 17.045 43.455 17 43.3996 17H28.9174'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-dasharray='5.02 5.02'
      />
      <path
        d='M19.4338 23.914C19.2587 23.8761 19.0835 23.8378 18.9116 23.7996C18.0293 23.6039 17.2996 23.4275 17.069 23.3432C16.8647 23.2686 16.7672 23.1813 16.7302 23.127C16.7142 23.1035 16.7067 23.083 16.7036 23.0605C16.7031 23.0571 16.7027 23.0532 16.7024 23.0488C16.7451 23.0486 16.7952 23.0517 16.8505 23.0589L19.4338 23.914ZM19.4338 23.914C19.4018 23.9016 19.3695 23.8891 19.337 23.8765C18.5473 23.5719 17.68 23.2693 17.0595 23.1006L19.4338 23.914Z'
        stroke='currentColor'
        stroke-width='1.29058'
      />
      <path
        d='M21.4373 21.4732C21.1744 21.2789 20.9052 21.0784 20.6453 20.883C19.8846 20.311 19.2587 19.8217 19.072 19.6382C18.9053 19.4743 18.8447 19.3418 18.8311 19.2638C18.8251 19.2292 18.8271 19.2008 18.8356 19.1723C18.8393 19.1598 18.8453 19.144 18.8552 19.125C18.9057 19.1448 18.9653 19.1753 19.0294 19.215C19.1013 19.2596 19.1667 19.3083 19.2158 19.349C19.7392 19.7827 20.4408 20.4525 21.0664 21.0898C21.1959 21.2218 21.3202 21.3503 21.4373 21.4732Z'
        stroke='currentColor'
        stroke-width='1.29058'
      />
      <path
        d='M22.3615 17.0386C22.6761 17.621 23.0654 18.4717 23.4008 19.2688C23.3153 19.1275 23.2302 18.9863 23.1468 18.8471C22.663 18.0399 22.2703 17.3576 22.1661 17.1209C22.0713 16.9054 22.0863 16.8373 22.0981 16.7818C22.1026 16.7606 22.0911 16.6866 22.0976 16.679L22.0987 16.6777C22.1966 16.7709 22.2965 16.9182 22.3615 17.0386Z'
        stroke='currentColor'
        stroke-width='1.29058'
      />
      <circle
        cx='30'
        cy='27.5'
        r='2.5'
        stroke='currentColor'
        stroke-width='1.5'
      />
    </svg>
  )
}
